import { INSTAGRAM_USERNAME, FACEBOOK_USERNAME, TWITTER_USERNAME, YOUTUBE_LINK, PINTEREST_USERNAME } from '~/constants/config';

export const socialMediaAccounts = [
  {
    name: 'Instagram',
    icon: 'instagram',
    link: `https://instagram.com/${INSTAGRAM_USERNAME}`,
    class: 'bg-instagram',
  },
  {
    name: 'Facebook',
    icon: 'facebook',
    link: `https://facebook.com/${FACEBOOK_USERNAME}`,
    background: '#3b55a0',
  },
  {
    name: 'Twitter',
    icon: 'twitter',
    link: `https://twitter.com/${TWITTER_USERNAME}`,
    background: '#333333',
  },
  {
    name: 'Youtube',
    icon: 'youtube',
    link: YOUTUBE_LINK,
    background: '#e52d27',
  },
  {
    name: 'Pinterest',
    icon: 'pinterest',
    link: `https://pinterest.com/${PINTEREST_USERNAME}`,
    background: '#bd081c',
  },
  {
    name: 'Whatsapp',
    icon: 'whatsapp',
    link: '',
    background: '#2ab200',
  },
];
